<template>
  <div class="app">
    <!-- <DeviceList
      v-bind:isVisible="isChildVisible"
      class="list"
      @change-style="activateStyle"
    ></DeviceList> -->
    <DeviceList v-bind:isVisible="isChildVisible" class="list"></DeviceList>
    <div class="main">
      <div class="title" :class="active == 1 ? 'blackTheme' : ''"></div>
      <router-link to="/device" class="tab">
        <div :style="active == 1 ? 'color:#fff' : ''">首页</div>
      </router-link>
      <!-- <div @mouseenter="isChildVisible = true" class="tab">
        <div
          :style="active == 1 ? 'color:#fff' : ''"
          :class="{ active1: isActive }"
        >
          精力舱
        </div>
      </div> -->
      <div @mouseenter="isChildVisible = true" class="tab">
        <div :style="active == 1 ? 'color:#fff' : ''">精力舱</div>
      </div>
      <router-link to="/mood" class="tab">
        <div :class="active == 1 ? 'tab1' : ''">技术原理</div>
      </router-link>
      <router-link to="/home" class="tab">
        <div :style="active == 1 ? 'color:#fff' : ''">关于我们</div>
      </router-link>
    </div>
  </div>
</template>
<script>
import DeviceList from "@/components/common/DeviceList";
export default {
  props: ["active"],
  components: {
    DeviceList,
  },
  data() {
    return {
      isChildVisible: false,
      // isActive: false,
    };
  },
  mounted() {
    // document.querySelectorAll("html")[0].scrollTop = 0;
    document.addEventListener("click", this.handleClickOutside, true);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside, true);
  },
  methods: {
    // 跳转测评详情页
    // tab(id) {
    //   this.active = id;
    //   if (id == 1) {
    //     this.$router.push("/");
    //   } else if (id == 2) {
    //     this.$router.push("/mood");
    //   } else {
    //     this.$router.push("/sleep");
    //   }
    // },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.isChildVisible = false;
      }
    },
    activateStyle() {
      this.isActive = true;
    },
  },
};
</script>
<style scoped>
* {
  font-family: "fontnormal";
}

.app {
  position: absolute;
  z-index: 99;
  top: 0;
}

.main {
  display: flex;
  margin: 2.55vw 8.75vw;
}

.title {
  /* width: 8.8vw;
  height: 1.56vw; */
  width: 8.5417vw;
  height: 1.25vw;
  /* font-size: 1.6vw; */
  /* font-family: SourceHanSansCN-Bold, SourceHanSansCN; */
  /* font-weight: bold; */
  /* color: #ffffff; */
  /* letter-spacing: 1px; */
  margin-right: 6.25vw;
  /* background: url(../../assets/logo.png) no-repeat; */
  background: url(../../assets/logo1.png) no-repeat;
  background-size: 100% 100%;
}

.blackTheme {
  background: url(../../assets/logo.png) no-repeat;
  background-size: 100% 100%;
}

.tab {
  font-size: 0.9vw;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  color: #333333;
  margin-right: 5vw;
  cursor: pointer;
  line-height: 1.25vw;
}

.tab1 {
  color: #1b1e8a !important;
}

.router-link-exact-active {
  font-size: 0.9vw;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  color: #1b1e8a !important;
  margin-right: 5vw;
  cursor: pointer;
}

.router-link-exact-active {
  border-bottom: 0.1vw solid #1b1e8a;
}

.list {
  position: absolute;
  margin-top: 6.7vw;
}

.active1 {
  color: #1b1e8a !important;
  border-bottom: 0.1vw solid #1b1e8a;
}
</style>



// WEBPACK FOOTER //
// src/components/common/HeaderBar.vue